<script setup lang="ts">
import { ref,onMounted,computed, reactive } from 'vue'
import CheckBox from "../../compositions/CheckBox.vue";
import ModalAppDialog from "../../compositions/ModalAppDialog.vue";
import config from "../../config.js";
import { confirmAlertApp } from "../../plugins/alert_app";
import { screenTransition,callBarcode,callSound,authCheck } from "../../plugins/flutter";
import axios from '../../plugins/axios.ts';
import { useAuditStore } from '../../stores/audit';

const audit = useAuditStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    user:{
      type:Object,
      required:true,
    },
    isAuditError:{
      type:Boolean,
      required:true,
    },
    medicines:{
      type:Array,
      required:true,
    },
    prescriptMedicineIds:{
      type:Array,
      required:true,
    },
    staffId:{
      type:Number,
      required:true,
    },
    prescriptId:{
      type:Number,
      required:true,
    },
    viewMode:{
      type:Number,
      required:true,
    },
})

const isErrorDialog = ref(props.isAuditError);
const selectPrescriptMedicineIds = reactive(props.prescriptMedicineIds);
const closeErrorDialog = () => {
  isErrorDialog.value = false;
}
const isLoading = ref(false);
const updateAuditCheckConfirm = async () => {
  let result = await confirmAlertApp('監査チェック状況を登録しますか？');
  if (result.isConfirmed) {
    await updateAuditCheck()
  }
}
const updateAuditCheck = async () => {
  isLoading.value = true;
  let params = {
    'prescript_id': props.prescriptId,
    'staff_id': props.staffId,
    'prescript_medicine_prescript_medicine_ids': audit.audit_medicines,
  };
  try {
    const response = await axios(props.apis.pharmacy_audit_check_update,{method:"post",data:params});
    if (response.data.status == 200) {
      //TOP画面に遷移
      screenTransition(config.SPAPP_MENU['HOME']);
    }
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  authCheck(props.user);
  if (props.viewMode == 0) {
    for (let i=0;i<selectPrescriptMedicineIds.length;i++) {
      audit.save_data(selectPrescriptMedicineIds[i]);
    }
    if (props.isAuditError == false) {
      //全ての薬剤のチェックが完了したら
      if (audit.audit_medicines.length == props.medicines.length) {
        callSound(config.SPAPP_SOUND['完了']);
      } else {
        callSound(config.SPAPP_SOUND['通常']);
      }
    } else {
      callSound(config.SPAPP_SOUND['エラー']);
    }
  }
});
const onChangeAuditCheck = (value,option) => {
  if (value) {
    audit.save_data(option.prescript_medicine_id);
    if (selectPrescriptMedicineIds.includes(option.prescript_medicine_id) == false) {
      selectPrescriptMedicineIds.push(option.prescript_medicine_id);
    }
  } else {
    audit.delete_data(option.prescript_medicine_id)
    if (selectPrescriptMedicineIds.indexOf(option.prescript_medicine_id) != -1) {
      selectPrescriptMedicineIds.splice(selectPrescriptMedicineIds.indexOf(option.prescript_medicine_id),1);
    }
  }
}
const isChecked = computed(() => {
  return (prescriptMedicineId) => {
    let result = false;
    for (let i=0;i<audit.audit_medicines.length;i++) {
      if (audit.audit_medicines[i] == prescriptMedicineId) {
        result = true;
        break;
      }
    }
    return result;
  }
});
const isCurrentMedicine = computed(() => {
  return (prescriptMedicineId) => {
    return selectPrescriptMedicineIds.includes(prescriptMedicineId);
  }
});
const medicineInfo = computed(() => {
  return (medicine) => {
    let result = medicine.drug_name;
    if (medicine.storage_bin.length > 0) {
      result += '<br>【棚番】<br>';
      for (let i=0;i<medicine.storage_bin.length;i++) {
        result += medicine.storage_bin[i] + '<br>';
      }

    }
    return result;
  }
})
const callDeviceBarcode = () => {
  //バーコード呼び出し
  callBarcode(config.SPAPP_MENU['監査チェック'])
}
</script>

<style scoped>
table td {
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
}
.list {
  border: 1px solid #ccc;
}
table {
  width:100%;
  border-collapse:collapse;
}
table > tbody > tr {
  border-bottom:1px solid #ccc;
}
table > tbody > tr > td {
  padding:0.5em;
  border-right:1px solid #ccc;
}
div.check {
  content: '';
  width: 10px;
  height: 5px;
  border-left: 3px solid white;
  border-bottom: 3px solid white;
  transform: rotate(-45deg);
}
.button {
  background-color:#F59E12;
  color:white;
  width:100%;
  border-radius: 0.5em;
  padding:0.5em 3em 0.5em 3em;
}
.submit-button {
  background-color: #1235F5;
  color: white;
  color:white;
  width:100%;
  border-radius: 0.5em;
  padding:0.5em 3em 0.5em 3em;
}
</style>
<template>
<div ref="element" class="relative">
  <div class="w-full p-2">
    <p class="text-lg mb-2">現在の監査チェック状況　({{ audit.audit_medicines.length }} / {{ medicines.length }})</p>
    <div class="overflow-y-auto list mb-2" style="height:75vh;">
      <table>
        <tbody>
          <tr v-for="(medicine,index) in medicines" :key="medicine.id" :style="(isCurrentMedicine(medicine.id) ? 'background-color:#F59E12;color:white;' : (isChecked(medicine.id) ? 'background-color:rgb(225, 223, 223);' : ''))">
            <td class="w-1/12">
              <div class="w-full flex items-center justify-center">
                <check-box
                  label=''
                  :value="isChecked(medicine.id)"
                  :value-options="{prescript_medicine_id:medicine.id}"
                  :on-change="onChangeAuditCheck"
                ></check-box>
              </div>
            </td>
            <td class="text-center w-8/12" v-html="medicineInfo(medicine)">
            </td>
            <td class="text-center w-3/12">
              {{ (medicine.prescript_usage.number_day_times > 0 ? medicine.prescript_usage.number_day_times * medicine.dosage : medicine.dosage) }}{{ medicine.dosage_unit }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mb-4">
      <button v-show="audit.audit_medicines.length != props.medicines.length" type="button" @click="callDeviceBarcode()" class="button">バーコード読み込み</button>
    </div>
    <div class="mb-8">
      <button type="button" @click="updateAuditCheckConfirm()" class="submit-button">監査チェック登録</button>
    </div>
  </div>
</div>
<modal-app-dialog
  :is-visible="isErrorDialog"
  :close="closeErrorDialog"
  cancel-button-name="閉じる"
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="text-lg text-red-700">異なる採用品があります。正しい採用品を集めてください。</div>
  </div>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isLoading"
  cancel-button-name=""
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="text-md">登録中です。しばらくお待ちください。</div>
  </div>
  </template>
</modal-app-dialog>

</template>

